import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [{ index: true, element: <Home /> }],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;